module.exports = __webpack_public_path__ + "assets/img/extractionTarot.eaa5285a.png";